import { render, staticRenderFns } from "./FamilyDataInfoGuardians.vue?vue&type=template&id=10da0a58&scoped=true&"
import script from "./FamilyDataInfoGuardians.vue?vue&type=script&lang=ts&"
export * from "./FamilyDataInfoGuardians.vue?vue&type=script&lang=ts&"
import style0 from "./FamilyDataInfoGuardians.vue?vue&type=style&index=0&id=10da0a58&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10da0a58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
